import { Component, Input } from '@angular/core';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

@Component({
  selector: 'wl-input-group',
  templateUrl: './input-group.component.html',
  styleUrls: [
    './input-group.component.ed.scss',
    './input-group.component.essent.scss',
  ],
  standalone: true,
  imports: [FaIconComponent],
})
export class InputGroupComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() icon?: IconProp;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() suffix?: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() valid?: boolean;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() invalid?: boolean;
}
